import { FormHelperText, FormLabel, Stack, TextFieldProps } from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { useErrorMessageResolver } from '../../localization/useErrorMessageResolver';
import { BooleanIndicator } from '../table/BooleanIndicator';

// todo: this component is used as readonly for now. Change to switch when this function is required

export type FormBooleanIndicatorProps = {
  control: Control<any>;
  name: string;
  readonly?: boolean;
  label?: string;
  helperText?: string;
} & Omit<TextFieldProps, 'name'>;
export const FormBooleanIndicator = ({ control, name, readonly, label, helperText }: FormBooleanIndicatorProps) => {
  const resolveErrorMessage = useErrorMessageResolver();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, ...fieldRest }, fieldState: { error } }) => (
        <Stack flex={1} spacing={1}>
          <FormLabel error={!!error}>{label}</FormLabel>
          <BooleanIndicator value={value} />
          <FormHelperText error={!!error}>{resolveErrorMessage(error?.message) ?? helperText}</FormHelperText>
        </Stack>
      )}
    />
  );
};
